// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"1127a144e4e4bb47","420":"b14e9e59d04fa254"}[chunkId] + ".css";
};